import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getCameras } from '../services/getCameras.service';
import { toCameraApiError } from '../services/cameraApiRequest';

/** The project's cameras (without passwords; UIDs only for managers). */
export const loadCameras = createAsyncThunk(
  'cameras/loadCameras',
  async ({ projectId }, { getState, rejectWithValue }) => {
    try {
      const activeEmployerInfo = selectUserActiveEmployerInfo(getState());
      const { cameras } = await getCameras({ projectId, activeEmployerInfo });
      return cameras || [];
    } catch (error) {
      return rejectWithValue(toCameraApiError(error));
    }
  }
);
